import { render, staticRenderFns } from "./developerOptimiser.vue?vue&type=template&id=2d2b81bd&scoped=true&"
import script from "./developerOptimiser.vue?vue&type=script&lang=js&"
export * from "./developerOptimiser.vue?vue&type=script&lang=js&"
import style0 from "./developerOptimiser.vue?vue&type=style&index=0&id=2d2b81bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b81bd",
  null
  
)

export default component.exports